import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAnomaliesServiceRequest } from "../services/anomaly/actions";
import { Signal } from "lucide-react";
import DataTable from "@/components/DataTable";
import { Button } from "@/components/ui/button";
import { AlertCircle, Circle } from "lucide-react";

const columns = [
  { header: "Anomali ID", accessor: "id" },
  { header: "Tarih", accessor: "timestamp" },
  { header: "Anomali Seviyesi", accessor: "anomalyLevel" },
  { header: "Anomali Tespit Edilen Node", accessor: "nodeId" },
];

export default function AnomalyStatus() {
  const dispatch = useDispatch();
  const { anomalies, loading, error } = useSelector((state) => state.anomaly);

  useEffect(() => {
    fetchAnomalies();
  }, []);

  const fetchAnomalies = () => {
    dispatch(getAnomaliesServiceRequest());
  };

  const handleRefresh = () => fetchAnomalies();

  // Icon rendering function
  const getLevelIcon = (level) => {
    switch (level) {
      case "Yüksek":
        return <AlertCircle className="text-red-500" />;
      case "Orta":
        return <AlertCircle className="text-yellow-500" />;
      case "Düşük":
        return <Circle className="text-blue-500" />;
      default:
        return null;
    }
  };

  // Function to set row background color based on status - FIXED
  const getRowBackgroundColor = (status) => {
    if (!status) {
      return "bg-white";
    }

    switch (status) {
      case "Yüksek":
        return "bg-red-100";
      case "Orta":
        return "bg-yellow-100";
      case "Düşük":
        return "bg-white";
      default:
        return "bg-white";
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center h-screen">
        <p className="text-red-500 mb-4">{error}</p>
        <button
          onClick={fetchAnomalies}
          className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
        >
          Yeniden Dene
        </button>
      </div>
    );
  }

  // Filter out any null/undefined items from anomalies array
  const validAnomalies = (anomalies || [])
    .filter((anomaly) => anomaly != null)
    .map((anomaly) => ({
      ...anomaly,
      status: anomaly.anomalyLevel,
    }));

  return (
    <div className="px-6 py-4 w-full min-w-0">
      <div className="flex justify-between items-center mb-6">
        <div className="flex items-center gap-3">
          <Signal />
          <h1 className="text-2xl font-bold">Anomali Tespitleri</h1>
        </div>
        <Button variant="refresh" onClick={handleRefresh} />
      </div>

      <DataTable
        data={validAnomalies}
        columns={columns}
        caption="Anomali tespit geçmişi"
        itemsPerPage={10}
        getLevelIcon={getLevelIcon}
        getRowBackgroundColor={getRowBackgroundColor}
        isAddButtonEnabled={false}
      />
    </div>
  );
}
